
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { getPartList } from '@/api/apis';
import DiagramItem from './DiagramItem.vue';
import Banner from '@/components/banner/Banner.vue';

export default defineComponent({
  name: 'Diagram',
  components: {
    DiagramItem,
    Banner
  },
  data() {
    return {
      loading: false,
      loaded: false,
      diagrams: [],
      pageNo: 1,
      pageSize: 8,
      pageSizeOptions: ['8', '16'],
      current: 1,
      total: 0,
      // params & query
      cataId: 0,
      model: '',
      vehicleId: 0,
      partName: ''
    };
  },
  created() {
    const route = useRoute();

    const params = route.params;

    const query = route.query;

    const pageNo = localStorage.getItem('diagramPageNo') || '';

    if (pageNo && !isNaN(+pageNo)) {
      this.pageNo = +pageNo || 1;
      localStorage.removeItem('diagramPageNo');
    }

    this.model = query.model as string;

    this.partName = query.partName as string;

    if (params.vehicleId && params.cataId) {
      this.cataId = Number(params.cataId);

      this.vehicleId = Number(params.vehicleId);

      if (this.cataId > 0 && this.vehicleId > 0) {
        this.loadData();
      }
    }
  },
  methods: {
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;

      const res = await getPartList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        vehicleId: this.vehicleId,
        parentId: this.cataId,
        type: 2 // 图组
      });

      if (res.success) {
        const data = res.result || {};

        this.diagrams = data.records || [];

        this.total = data.total;
      }

      this.loading = false;

      this.loaded = true;
    }
  }
});
